/*
* @Author: UEDHE
* @Date:   2018-05-10 16:28:30
* @Last Modified by:   UEDHE
* @Last Modified time: 2018-07-24 11:42:00
*/
import Vue from 'vue'
import ScrollLoad from './scrollLoad/scrollLoad'
import PullRefresh from './pullRefresh/pullRefresh'
import Ewm from './ewm/ewm'
const components = [
  ScrollLoad,
  PullRefresh,
  Ewm
]

// 将所有组件保存到vue上后面在页面上可以直接使用daq-tabbar
for (let i = 0; i < components.length; i++) {
  Vue.component(components[i].name, components[i])
}



// WEBPACK FOOTER //
// ./src/components/index.js